import { useState } from "react";

import { Button } from "../Button";
import { StyledContainer, StyledInput } from "./styles";

export function Input({
  placeholder,
  button,
  inputStyle = "normal",
  size = "normal",
  onSubmit,
  inline = false,
  ...props
}) {
  const [focus, setFocus] = useState(false);

  return (
    <StyledContainer
      focused={focus}
      inputStyle={inputStyle}
      size={size}
      inline={inline}
    >
      <StyledInput
        inline={inline}
        focused={focus}
        type="text"
        placeholder={placeholder}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        inputStyle={inputStyle}
        size={size}
        {...props}
      />
      <Button
        color={button?.color || "#0033FF"}
        size={size}
        buttonStyle={button?.buttonStyle || "normal"}
        onClick={onSubmit}
      >
        {button?.label || "Click"}
      </Button>
    </StyledContainer>
  );
}